// generated from 56 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const attributedAdgroupFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("attributed_adgroup_filter"),
  comparison_key: z.enum([
    "1", // 50 (89.29%)
    "10", // 5 (8.93%)
    "2", // 1 (1.79%)
  ]),
  display_name: z.string(),
  // undefined: 6 (10.71%), defined 50 (89.29%)
  // format integer: 50 (100.00%)
  raw_value: z.string().optional(),
  // format integer: 50 (89.29%)
  value: z.string(),
  varies_by_app_group: z.literal(true),
});
